import { Box, CircularProgress, Typography } from '@mui/material';

const BSCircularProgress = ({ size, thickness, caption, color }) => {
  return (
    <Box display={'flex'} flexDirection="column" justifyContent={'center'} alignItems="center">
      <CircularProgress size={size} thickness={thickness} color={color} />
      <Typography variant="caption">{caption}</Typography>
    </Box>
  );
};

export default BSCircularProgress;
